export default __webpack_public_path__ + "static/media/icon-reachabove.0d5f4167.svg";